module.exports = __webpack_public_path__ + "media/metronic/_theme/media/bg/sc-home1-bg-43f4980dbd5aabc07682344afa5c04d9.png";